import axios from "axios";
import Swal from "sweetalert2";
import userData from "@/plugins/userData";
import { FwbAlert } from "flowbite-vue";
import Highcharts from "highcharts";
import InputSelect from "@/components/forms/InputSelectProfil.vue";

export default {
  mixins: [userData],
  name: "DashboardPage",
  components: {
    FwbAlert,
    InputSelect,
  },
  data() {
    return {
      data_status: {
        jumlah_pemberkasan: 0,
        jumlah_proses_verifikasi: 0,
        jumlah_berkas_tidak_lengkap: 0,
        jumlah_pengajuan_ditolak: 0,
        jumlah_pengajuan_diterima: 0,
        jumlah_pencairan_bantuan: 0,
        jumlah_selesai: 0,
      },
      // Status summary untuk visualisasi baru
      status_summary: {
        total: 0,
        pemberkasan: 0,
        proses_verifikasi: 0,
        berkas_tidak_lengkap: 0,
        ditolak: 0,
        pengajuan_diterima: 0,
        rekening_tidak_sesuai: 0,
        berkas_lengkap: 0,
        siap_pencairan: 0,
        selesai_cair: 0,
        diterima: 0,
      },
      filter: {
        periode: "20251",
      },
      listPeriode: [{ value: "20242", text: "Periode 2024 Genap" }],
      count_mahasiswa: 0,
      count_pengajuan: 0,
      openRegister: 0,
      data_by_kec: [],
      data_by_kampus: [],
      isLoading: false,
      aboutData: null,
    };
  },
  mounted() {
    this.initPeriode();
    this.fetchAvailablePeriods();
    this.fetchData();
    this.fetchAboutData();
  },
  computed: {
    listPeriodeAuto() {
      const year = new Date().getFullYear();
      return [
        { value: `${year - 1}2`, text: `Periode ${year - 1} Genap` },
        { value: `${year}1`, text: `Periode ${year} Ganjil` },
      ];
    },
    // Hitung persentase untuk setiap status
    statusPercentages() {
      if (this.status_summary.total === 0) return {};
      return {
        pemberkasan: (
          ((this.status_summary.pemberkasan || 0) / this.status_summary.total) *
          100
        ).toFixed(1),
        proses_verifikasi: (
          ((this.status_summary.proses_verifikasi || 0) /
            this.status_summary.total) *
          100
        ).toFixed(1),
        berkas_tidak_lengkap: (
          ((this.status_summary.berkas_tidak_lengkap || 0) /
            this.status_summary.total) *
          100
        ).toFixed(1),
        ditolak: (
          ((this.status_summary.ditolak || 0) / this.status_summary.total) *
          100
        ).toFixed(1),
        diterima: (
          ((this.status_summary.diterima || 0) / this.status_summary.total) *
          100
        ).toFixed(1),
        selesai_cair: (
          ((this.status_summary.selesai_cair || 0) /
            this.status_summary.total) *
          100
        ).toFixed(1),
      };
    },
    // Label dinamis untuk Pemberkasan/Gagal Pemberkasan
    pemberkasanLabel() {
      if (this.aboutData && this.filter.periode) {
        const now = new Date();
        const closeDate = this.aboutData.date_close_registration
          ? new Date(this.aboutData.date_close_registration)
          : null;

        // Jika sudah melewati tanggal tutup pendaftaran
        if (closeDate && now > closeDate) {
          return "Gagal Pemberkasan";
        }
      }
      return "Pemberkasan";
    },
  },
  watch: {
    "filter.periode"() {
      this.fetchData();
      this.fetchAboutData();
    },
  },
  methods: {
    getAutoPeriode() {
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth() + 1;

      if (month >= 1 && month <= 6) {
        return `${year - 1}2`;
      }
      return `${year}1`;
    },
    initPeriode() {
      this.syncPeriodeOptions(this.listPeriode);
      this.filter.periode = this.getAutoPeriode();
    },
    syncPeriodeOptions(periods = []) {
      const autoPeriode = this.getAutoPeriode();
      const selectedPeriode = this.filter.periode;
      const mergedPeriods = [...periods];

      [autoPeriode, selectedPeriode].forEach((periode) => {
        if (
          periode &&
          !mergedPeriods.some((item) => item.value === periode)
        ) {
          const year = periode.substring(0, 4);
          const semester = periode.endsWith("1") ? "Ganjil" : "Genap";
          mergedPeriods.push({
            value: periode,
            text: `Periode ${year} ${semester}`,
          });
        }
      });

      this.listPeriode = mergedPeriods.sort((a, b) =>
        b.value.localeCompare(a.value)
      );
    },
    fetchAvailablePeriods() {
      axios
        .get("/available-periods")
        .then((response) => {
          this.syncPeriodeOptions(response.data?.data || []);
        })
        .catch((error) => {
          console.error("Error fetching periods:", error);
          this.syncPeriodeOptions(this.listPeriode);
        });
    },
    fetchAboutData() {
      axios
        .get("/about/", {
          params: {
            periode: this.filter.periode,
          },
        })
        .then((response) => {
          this.aboutData = response.data;
        })
        .catch((error) => {
          console.error("Error fetching about data:", error);
        });
    },
    fetchData() {
      this.isLoading = true;
      axios
        .get("/dashboard/", {
          headers: {
            "X-Token": this.userToken,
          },
          params: {
            periode: this.filter.periode,
          },
        })
        .then((response) => {
          this.count_mahasiswa = response.data.data_count_mahasiswa;
          this.count_pengajuan = response.data.data_count_pengajuan;
          this.data_by_kec = response.data.data_by_kec;
          this.data_by_kampus = response.data.data_by_kampus;

          for (let key in response.data.data_by_status) {
            this.data_status[key] = response.data.data_by_status[key];
          }

          // Set status summary dari response
          if (response.data.status_summary) {
            this.status_summary = response.data.status_summary;
          }

          this.fetchStatusLaunch();
          this.renderKecamatan();
          this.renderKampus();
          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error);
          this.error = error.message;
          this.isLoading = false;
        });
    },
    renderKecamatan() {
      if (this.$refs.barKecamatan) {
        Highcharts.chart(this.$refs.barKecamatan, {
          chart: {
            type: "column",
          },
          credits: {
            enabled: false,
          },
          title: {
            text: "Grafik Permohonan Bantuan Berdasarkan Kecamatan",
          },
          accessibility: {
            announceNewData: {
              enabled: true,
            },
          },
          xAxis: {
            type: "category",
          },
          yAxis: {
            title: {
              text: "Jumlah",
            },
            labels: {
              formatter: function () {
                return this.value;
              },
            },
          },
          legend: {
            enabled: false,
          },
          plotOptions: {
            series: {
              borderWidth: 0,
              dataLabels: {
                enabled: true,
                formatter: function () {
                  return Highcharts.numberFormat(this.y, 0, ",", ".");
                },
              },
            },
          },
          tooltip: {
            valueSuffix: " permohonan",
          },
          series: [
            {
              name: "Jumlah",
              data: this.data_by_kec.map((data) => ({
                name: data.kec,
                y: parseInt(data.jumlah),
              })),
              colorByPoint: true,
            },
          ],
          exporting: {
            buttons: {
              contextButton: {
                menuItems: ["viewFullscreen", "downloadJPEG", "downloadXLS"],
              },
              menuButtonTextKey: {
                viewFullscreen: "Tampilkan Layar Penuh",
              },
            },
          },
        });
      }
    },
    renderKampus() {
      if (this.$refs.barKampus) {
        Highcharts.chart(this.$refs.barKampus, {
          chart: {
            type: "bar",
          },
          credits: {
            enabled: false,
          },
          title: {
            text: "Grafik Permohonan Bantuan Berdasarkan Asal Kampus",
          },
          accessibility: {
            announceNewData: {
              enabled: true,
            },
          },
          xAxis: {
            type: "category",
          },
          yAxis: {
            title: {
              text: "Jumlah",
            },
            labels: {
              formatter: function () {
                return this.value;
              },
            },
          },
          legend: {
            enabled: false,
          },
          plotOptions: {
            series: {
              borderWidth: 0,
              dataLabels: {
                enabled: true,
                formatter: function () {
                  return Highcharts.numberFormat(this.y, 0, ",", ".");
                },
              },
            },
          },
          tooltip: {
            valueSuffix: " permohonan",
          },
          series: [
            {
              name: "Jumlah",
              data: this.data_by_kampus.map((data) => ({
                name: data.kampus,
                y: parseInt(data.jumlah),
              })),
              colorByPoint: true,
            },
          ],
          exporting: {
            buttons: {
              contextButton: {
                menuItems: ["viewFullscreen", "downloadJPEG", "downloadXLS"],
              },
              menuButtonTextKey: {
                viewFullscreen: "Tampilkan Layar Penuh",
              },
            },
          },
        });
      }
    },
    confirmLaunch() {
      Swal.fire({
        title: "Luncurkan Aplikasi ?",
        text: "Aplikasi akan segera aktif",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Batal",
        confirmButtonText: "Luncurkan !",
      }).then((result) => {
        if (result.value) {
          this.launchApp();
        }
      });
    },
    launchApp() {
      this.isLoading = true;
      try {
        axios
          .get(`/v1/about/launch/`, {
            headers: {
              token: this.userToken,
            },
          })
          .then((response) => {
            Swal.fire({
              title: "Sukses",
              text: response.data.message,
              icon: "success",
              showCancelButton: false,
              confirmButtonColor: "#3085d6",
              confirmButtonText: "OK!",
            }).then(() => {
              this.isLoading = false;
              this.fetchData();
            });
          })
          .catch((error) => {
            Swal.fire({
              title: "Gagal",
              text: "Gagal Meluncurkan Aplikasi",
              icon: "error",
              showCancelButton: false,
              confirmButtonColor: "#3085d6",
              confirmButtonText: "OK!",
            }).then(() => {
              this.isLoading = false;
              this.fetchData();
            });
            this.error = error.message;
          });
      } catch (err) {
        this.isLoading = false;
        console.error(err);
      }
    },
    pauseLaunch() {
      this.isLoading = true;
      try {
        axios
          .get(`/v1/about/unlaunch/`, {
            headers: {
              token: this.userToken,
            },
          })
          .then((response) => {
            Swal.fire({
              title: "Sukses",
              text: response.data.message,
              icon: "success",
              showCancelButton: false,
              confirmButtonColor: "#3085d6",
              confirmButtonText: "OK!",
            }).then(() => {
              this.isLoading = false;
              this.fetchData();
            });
          })
          .catch((error) => {
            Swal.fire({
              title: "Gagal",
              text: "Gagal Meluncurkan Aplikasi",
              icon: "error",
              showCancelButton: false,
              confirmButtonColor: "#3085d6",
              confirmButtonText: "OK!",
            }).then(() => {
              this.isLoading = false;
              this.fetchData();
            });
            this.error = error.message;
          });
      } catch (err) {
        this.isLoading = false;
        console.error(err);
      }
    },
    fetchStatusLaunch() {
      axios
        .get("/v1/about/")
        .then((response) => {
          this.openRegister = response.data.open_registrasi;
        })
        .catch((error) => {
          console.log(error);
          this.error = error.message;
        });
    },
  },
};
